import { useEffect, useRef, useState } from "react";
import { Controller } from "react-hook-form";
import { fontSizes } from "../../constants/constants";
import { Text } from "../index";
import textWeight from "../../utils/textWeight";

const CustomDropdown = ({
  options = [],
  control,
  name,
  label,
  valueoption,
  valueName,
  rightIcon,
  isLoadingpreFiled,
  isLoading,
  isMandatory,
  isRequired,
  onRateChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);
  const { TextWeight } = textWeight();
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      // Reset search term when opening dropdown
      setSearchTerm("");
      // Focus search input after a small delay to ensure it's visible
      setTimeout(() => {
        searchInputRef.current?.focus();
      }, 100);
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
      setSearchTerm("");
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const filteredOptions = options?.filter((option) =>
    option[valueName]?.toLowerCase()?.includes(searchTerm?.toLowerCase())
  );

  return (
    <Controller
      name={name}
      control={control}
      rules={isRequired ? {} : { required: `${label} is required` }}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        const selectedOption = options?.find(
          (option) => String(option[valueoption]) === String(value)
        );
        return (
          <div
            className={`relative ${
              isLoading || isLoadingpreFiled
                ? "opacity-50 cursor-not-allowed"
                : ""
            }`}
            w-full
            ref={dropdownRef}
          >
            {label && (
              <Text
                text={<>{label}</>}
                size={fontSizes.h16}
                weight={TextWeight.Onest_regular}
                isRequired={isMandatory}
                color=" xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 flex justify-start items-center text-secondary"
              />
            )}
            <div
              className={`relative px-2 bg-white xs:text-sm sm:text-base font-onestRegular py-1 rounded-xl text-black transition duration-300 delay-100 border
                            ${isOpen ? "border-black" : "border-[#CCCBCB]"}`}
              onClick={toggleDropdown}
            >
              <div className="flex items-center justify-between w-full">
                {isOpen ? (
                  <input
                    type="text"
                    placeholder="Search..."
                    className=" bg-transparent outline-none text-black"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    ref={searchInputRef}
                    autoFocus
                  />
                ) : (
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleDropdown(e);
                    }}
                  >
                    {selectedOption ? selectedOption[valueName] : `Select rate`}
                  </span>
                )}
                <img
                  className={`absolute right-1.5 top-1/2 -translate-y-1/2 w-4 h-4 transition-transform duration-500 ${
                    isOpen ? "rotate-180" : "rotate-0"
                  }`}
                  src={rightIcon}
                  alt="Dropdown icon"
                />
              </div>
            </div>
            {isOpen && (
              <div className="absolute z-10 w-full bg-white rounded-xl mt-2 max-h-32 overflow-y-auto scroll-container shadow-lg border-goldMetallic border">
                <ul className="text-black">
                  {filteredOptions.length > 0 ? (
                    filteredOptions.map((option, index) => (
                      <li
                        key={option[valueoption]}
                        onClick={() => {
                          onChange(option[valueoption]);
                          if (onRateChange) onRateChange(option[valueoption]);
                          setIsOpen(false);
                          setSearchTerm("");
                        }}
                        className={`py-3 relative cursor-pointer transition duration-300 px-2 
                                                ${
                                                  index !==
                                                  filteredOptions.length - 1
                                                    ? "after:absolute after:bottom-0 after:left-0 after:w-full after:h-[1.5px] after:bg-[#CCCBCB]"
                                                    : ""
                                                }`}
                      >
                        {option[valueName]}
                      </li>
                    ))
                  ) : (
                    <li className="py-3 text-center text-black">
                      No options found
                    </li>
                  )}
                </ul>
              </div>
            )}

            {/* {errors?.[name] && (
              <Text
                text={errors[name].message}
                color="text-orangeCrayola"
                size={fontSizes.h14}
                textWeight={TextWeight.Onest_regular}
                className={"xs:pl-6 sm:pl-6 lg:pl-8"}
                isTruncate={false}
              />
            )} */}
          </div>
        );
      }}
    />
  );
};

export default CustomDropdown;
